import angular from 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { MechanicService } from './mechanics.service';

angular.module('app-lite.mechanics', [])
  .service('mechanicsApi', downgradeInjectable(MechanicService));